import globals from '../globals';
export default {
    data() {
        return {
            warning_msg: ''
        }
    },
    components: {
        globals
    },
    methods: { 
        async getAuctionsDetails(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    console.log("JShi1")
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/auctions/`+params.auction_id+`?company_id=`+params.company_id+`&timezone=`+params.timezone);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    console.log("JShi2")
                    reject(error.response.data.reason)
                }
            })
        },
        async createBidderAPI(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + '/auctions/bidder/info', params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                }
            })
        },
    },
}